<template>
    <div class="container bg_white yj_news">
        <div class="banner"  :style="{backgroundImage: 'url(' + news_banner + ')', backgroundSize: 'cover', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat'}"></div>
        <div class="main width o_h">
            <!--<div class="news_l f_l">
                <el-card class="box-card m_t2" shadow="" :body-style="{ padding: '0' }">
                    <div class="news_l_box box_sizing black_color">
                        <img :src="news_icon" alt="" class="d_b">
                        <p class="m_t2 m_b1 font_20">奕杰动态</p>
                        <p class="font_16">NEWS</p>
                    </div>
                </el-card>
                 <ul class="news_ul m_t1">
                    <li :class="['pointer', {'news_active': index === idx}]" @mouseenter="newsItem(idx)"
                        v-for="(item, idx) in newsNav" :key="idx">{{item}}
                    </li>
                </ul>
            </div>-->
            <div class="news_r f_l p2 box_sizing" style="width: 100%">
                <ul class="news_r_ul">
                    <li class="m_b1 font_18 pointer" v-for="(item, idx) in newList"
                        :key="idx">
                        <router-link :to="{path: '/newsDetail', query: {id: JSON.stringify(item.id), type: JSON.stringify(2)}}">
                            <div class="news_img_box f_l o_h">
                                <img class="news_img" :src="item.img" alt="">
                                <!--<el-image class="news_img" :src="item.img" fit="cover"></el-image>-->
                            </div>
                            <div class="f_r p_t1 p_b1 box_sizing">
                                <h3 class="font_18 one_h m_b2">{{item.title}}</h3>
                                <p class="gray_color font_16 mr_h">查看详情</p>
                                <span class="gray_color font_16 d_b" style="margin-top: 45px;">{{item.updateTime}}</span>
                            </div>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="width paging_box m_t1 m_b2">
            <el-pagination
                    :hide-on-single-page="show"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {ImgUrl, OSSImgUrl} from '../api/common_api';
    import {newsList} from "../api/api";

    export default {
        name: "NewsList",
        data() {
            return {
                news_banner: ImgUrl + 'news_banner1.png',
                news_icon: ImgUrl + 'news_icon.png',
                // newsNav: ['新闻中心', '奕杰动态'],
                show: true,     //当只有一页时隐藏分页
                currentPage: 1, //当前页数
                pageSize: 10,    //每页展示条数
                newList: [],
                total: 0,   //总条数
                errorImg: require('../assets/image/error_yjdt.png'),
            }
        },
        created() {
            // console.log(this.$route.query)
            // 查询列表
            this.newsList();
        },
        methods: {
            // newsItem(idx) {
            //     if (this.index === idx) {
            //         return;
            //     }
            //     this.index = idx;
            // },
            /**
             * 分页
             * @param val:当前页码
             */
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.newsList(val)
            },
            /**
             * 查询教育资讯列表
             * pageStart:分页
             * pageSize:请求条数
             * listType:1:新闻 2:奕杰动态 3:知识库 4:企业推广
             * userType:用户类型 1:奕杰 2:学生 3:企业 4:学校 5:网站
             * searchKeyword:搜索关键词
             */
            newsList(pageStart = 1, pageSize = 10, listType = 2, userType = 3, userId = 0) {
                this.$loading({
                    text: "加载中...",
                    background: 'rgba(0, 0, 0, 0.2)'
                });
                let _params = {
                    pageStart: pageStart,
                    pageSize: pageSize,
                    listType: listType,
                    userType: userType,
                    userId: userId,
                };
                newsList(_params).then(res => {
                    this.$loading().close();
                    this.total = res.data.total;
                    let _list = res.data.list,
                        tmp_list = [];
                    for (let i = 0; i < _list.length; i++) {
                        let _src = _list[i].image ? (OSSImgUrl + _list[i].image.split(';')[0]) : this.errorImg;
                        tmp_list.push({
                            id: _list[i].id,
                            img: _src,
                            title: _list[i].title,
                            content: _list[i].content,
                            type: 1,  //1-教育资讯 2-奕杰动态
                            conType: _list[i].type,  //媒体类型 1:文章 2:视频
                            layoutType: _list[i].typesettingType,  //排版类型 1:纯文本 2:三张及以上图片 3:一/二张图片 4:视频
                            videoSrc: ((_list[i].type === 2) ? (OSSImgUrl +  _list[i].content.split(';')[0]) : ''),
                            updateTime: _list[i].updateTime,
                        })
                    }
                    this.pageStart = pageStart;
                    this.newList = tmp_list;
                    /*if (pageStart > 1) {
                        if (_list.length !== 0) {
                            let listOld = this.newList;
                            let listNew = listOld.concat(tmp_list);
                            this.pageStart = pageStart;
                            this.newList = listNew;
                        }
                    } else {
                        this.pageStart = 1;
                        this.newList = tmp_list;
                    }*/
                }).catch(err => {
                    console.log(err)
                })
            }
        },
    }
</script>

<style scoped lang="stylus">
    .container {
        .banner {
            width: 100%;
            height: 260px;
        }

        .main {
            min-height calc(100vh - 581px)

            .news_l {
                width 20%
                height 240px

                .news_l_box {
                    width 100%
                    height 240px
                    padding 48px 0
                    border 1px solid #bfbfbf

                    img {
                        width 85px
                        height 70px
                        margin 0 auto
                    }

                    p {
                        text-align center
                    }
                }

                .news_ul {
                    border 1px solid #ccc
                    border-top none


                    li {
                        border-top 1px solid #ccc
                        text-align center
                        line-height 40px
                    }
                }

                .news_active {
                    background #8a8a8a
                    color #ffffff
                }
            }

            .news_r {
                width 80%
                min-height 890px

                .news_r_ul {
                    li {
                        height 160px

                        .news_img_box {
                            width 240px
                            height 160px

                            .news_img {
                                width 100%
                                height 100%
                                background #f2f2f2
                                object-fit cover

                                &:hover {
                                    transform scale(1.1)
                                    transition all 0.5s
                                }
                            }
                        }

                        div {
                            width 72%

                            p {
                                line-height 32px
                                -webkit-line-clamp: 3

                                &:hover {
                                    color #333
                                }
                            }
                        }
                    }
                }
            }
        }

        .paging_box {
            text-align center
        }
    }
</style>
